module.exports = __webpack_public_path__ + "static/media/tiger.b272527c.png";